import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import * as React from "react";

interface IBeforeInstallPromptEvent extends Event {
    readonly platforms: string[];
    readonly userChoice: Promise<{
        outcome: "accepted" | "dismissed";
        platform: string;
    }>;
    prompt(): Promise<void>;
}

export function useAddToHomescreenPrompt(): [
    IBeforeInstallPromptEvent | null,
    () => void
] {
    const [prompt, setState] = React.useState<IBeforeInstallPromptEvent | null>(
        null
    );

    const promptToInstall = () => {
        if (prompt) {
            return prompt.prompt();
        }
        return Promise.reject(
            new Error(
                'Tried installing before browser sent "beforeinstallprompt" event'
            )
        );
    };

    React.useEffect(() => {
        const ready = (e: IBeforeInstallPromptEvent) => {
            e.preventDefault();
            setState(e);
        };

        window.addEventListener("beforeinstallprompt", ready as any);

        return () => {
            window.removeEventListener("beforeinstallprompt", ready as any);
        };
    }, []);

    return [prompt, promptToInstall];
}

export function Add2HSButton() {
    const [prompt, promptToInstall] = useAddToHomescreenPrompt();
    const [isVisible, setVisibleState] = React.useState(false);

    const hide = () => setVisibleState(false);

    React.useEffect(
        () => {
            if (prompt) {
                setVisibleState(true);
            }
        },
        [prompt]
    );

    if (!isVisible) {
        return <div />;
    }

    const promtAndHide = () => {
        promptToInstall();
        hide();
    }

    return (
        <div onClick={hide}>
            <Dialog onClose={hide} aria-labelledby="add2hs-modal" open={isVisible}>
                <DialogTitle id="add2hs-modal">Adicione a Tela Inicial</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Adicione o APC Mobile a tela inicial do seu dispositivo e utilize-o da mesma forma que os seus apps favoritos!
                    </DialogContentText>
                    <DialogActions>
                        <Button onClick={promtAndHide} color="primary">
                            Sim, eu quero
                         </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>

        </div>
    );
}